import request from '@/utils/request'
const BASE_URL = '/pdd/user'

export default {
  login(data) {
    return request({
      url: BASE_URL + '/login',
      method: 'post',
      data
    })
  },
}